import { Route } from '@angular/router';
import { AppRoute } from './app-route';
import { adminRoleGuard } from './auth/admin-role.guard';
import { authGuard } from './auth/auth.guard';
import { ConnectPermissionDeniedComponent } from './auth/connect-permission-denied/connect-permission-denied.component';
import { LoginComponent } from './auth/login/login.component';
import { LogoutComponent } from './auth/logout/logout.component';
import { NoAccessComponent } from './auth/no-access/no-access.component';
import { ConfigComponent } from './config/config.component';
import { Host3dComponent } from './connect-3d-ext/host-3d.component';
import { DialogDemoComponent } from './dialog/demo/dialog-demo.component';
import { TabHostComponent } from './hosts/tab-host/tab-host.component';
import { OneDriveAuthComponent } from './import/file-pickers/onedrive/onedrive-auth.component';
import { LicenseCheckComponent } from './license/license-check/license-check.component';
import { licenseGuard } from './license/license.guard';
import { LoadingDemoComponent } from './loading/loading-demo/loading-demo.component';
import { MapComponent } from './map/map.component';
import { redirectGuard } from './route/redirect.guard';
import { ScandataListComponent } from './scandata-list/scandata-list.component';

export const appRoutes: Route[] = [
  { path: AppRoute.Login, component: LoginComponent },
  { path: AppRoute.Logout, component: LogoutComponent },
  {
    path: AppRoute.Config,
    component: ConfigComponent,
    canActivate: [authGuard, licenseGuard, adminRoleGuard],
  },
  { path: AppRoute.Connect3d, component: Host3dComponent, canActivate: [authGuard, licenseGuard] },
  { path: AppRoute.ConnectPermissionDenied, component: ConnectPermissionDeniedComponent },
  { path: AppRoute.NoAccess, component: NoAccessComponent },
  { path: AppRoute.LicenseCheck, component: LicenseCheckComponent, canActivate: [authGuard] },
  { path: AppRoute.OneDriveAuth, component: OneDriveAuthComponent },
  {
    path: '',
    component: TabHostComponent,
    canActivate: [authGuard, licenseGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: MapComponent,
        canActivate: [redirectGuard],
      },
      {
        path: AppRoute.MapView,
        component: MapComponent,
      },
      {
        path: AppRoute.ListView,
        component: ScandataListComponent,
      },
    ],
  },
  { path: 'loading-demo', component: LoadingDemoComponent },
  { path: 'dialog-demo', component: DialogDemoComponent },
  { path: '**', redirectTo: '' },
];
